import { ButtonBase, alpha, styled } from '@mui/material'
import { CheckCircleIcon } from '@weblite/icons'

export const Root = styled('div')`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 16px 20px 20px;
`
export const CallTypeButtons = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 16px 0 32px;
  position: relative;
`

// TODO: Use classnames instead of data attributes
export const CallTypeButton = styled(ButtonBase)`
  width: 100%;
  padding: 12px 16px;
  border-radius: 12px;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  border: 1px solid #0000001a;

  &[disabled] {
    border: none;
    background-color: #eeeeef;
  }

  &[data-selected='true'] {
    &[data-call-type='tribune'] {
      border-color: ${({ theme }) => alpha(theme.palette.tribune500, 0.5)};
      background: ${({ theme }) => alpha(theme.palette.tribune500, 0.1)};
    }

    &[data-call-type='group_call'] {
      border-color: ${({ theme }) => alpha(theme.palette.primary500, 0.5)};
      background: ${({ theme }) => alpha(theme.palette.primary500, 0.1)};
    }

    &[data-call-type='live'] {
      border-color: ${({ theme }) => alpha(theme.palette.live500, 0.5)};
      background: ${({ theme }) => alpha(theme.palette.live500, 0.1)};
    }

    &[data-call-type='classroom'] {
      border-color: #ff1c7a80;
      background: linear-gradient(
        180deg,
        rgba(255, 97, 163, 0.1) 0%,
        rgba(255, 26, 121, 0.1) 100%
      );
    }

    &[data-call-type='announcement'] {
      border-color: ${({ theme }) => alpha(theme.palette.primary500, 0.5)};
      background: ${({ theme }) => alpha(theme.palette.primary500, 0.1)};
    }
  }
`

export const ComingSoonBadgeContainer = styled('div')`
  background-color: ${({ theme }) => theme.palette.secondary500};
  border-radius: 12px;
  padding: 4px 8px;
  color: ${({ theme }) => theme.palette.neutral000};
  position: absolute;
  top: 4px;
  left: 4px;
`
export const ButtonContent = styled('div')`
  gap: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-sizing: border-box;
  gap: 12px;
`

export const ButtonContentHeader = styled('div')`
  display: flex;
  gap: 10px;

  color: ${({ theme }) => theme.palette.neutral500};

  & svg {
    width: 24px;
    height: 24px;
    color: inherit;
  }

  &[data-selected='true'] {
    &[data-call-type='tribune'] {
      color: ${({ theme }) => theme.palette.tribune500};
    }

    &[data-call-type='group_call'] {
      color: ${({ theme }) => theme.palette.primary500};
    }

    &[data-call-type='live'] {
      color: ${({ theme }) => theme.palette.live500};
    }

    &[data-call-type='classroom'] {
      color: ${({ theme }) => theme.palette.live500};
    }

    &[data-call-type='announcement'] {
      color: ${({ theme }) => theme.palette.primary500};
    }
  }
`

export const StyledCheckCircleIcon = styled(CheckCircleIcon)`
  color: ${({ theme }) => theme.palette.success500};
  transition:
    opacity 0.3s ease,
    transform 0.3s ease;
  opacity: 0;
  transform: scale(0.8);
  &[data-selected='true'] {
    opacity: 1;
    transform: scale(1);
  }
`
